































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { TaskDetailParam } from '@/@types/LibraryComponent';

@Component
export default class TaskListTableEditableText extends Vue {
  // テキスト
  @Prop()
  private readonly taskId!: number | null;
  @Prop()
  public textData!: string | null;
  // 要素の表示形式を blockで表示させるかどうか
  @Prop({ type: Boolean })
  public dBlock!: boolean;
  @Prop({ default: false })
  private customFlag!: boolean;

  // 表示用テキスト
  private taskText: string | null = '';
  // 入力されたテキスト
  private inputText: string | null = '';
  // 編集中かどうか
  private isEditing: boolean = false;
  // 編集アイコンを表示するかどうか
  private isShowEditIcon: boolean = false;
  // 編集アイコンホバー時にテキスト欄を点線表示にする
  private isHover: boolean = false;
  /** 編集する属性名 */
  @Prop()
  private attribute!: string;

  @Emit('emitTaskData')
  private emitTaskData(text: string): TaskDetailParam {
    this.inputText = text;
    this.taskText = this.inputText;
    if (
      (this.customFlag && this.attribute.substr(-6, 6) === 'Number') ||
      this.attribute === 'ticketUnitPrice'
    ) {
      return {
        taskId: this.taskId,
        value: Number(text),
        attributeKey: this.attribute,
        customFlag: this.customFlag,
      };
    } else {
      return {
        taskId: this.taskId,
        value: text,
        attributeKey: this.attribute,
        customFlag: this.customFlag,
      };
    }
  }

  private mounted() {
    this.taskText = this.textData ? this.textData : null;
  }

  /**
   * 入力フィールド フォーカス外れた
   */
  private cancel(e: Event) {
    this.isEditing = false;
    this.isShowEditIcon = false;
  }

  /**
   * 確定
   */
  private complete(e: KeyboardEvent) {
    // 日本語入力中のEnterキー操作は無効にする
    if (e.keyCode !== 13) return;
    this.taskText = this.inputText;
    this.isEditing = false;
  }

  /**
   * 編集モードにする
   */
  private edit(e: Event) {
    e.stopPropagation();
    this.inputText = this.taskText;
    // 編集モード状態を反転
    this.isEditing = true;
    if (this.isEditing) {
      // 点線表示を消す
      this.isHover = false;
      // 入力フィールドにフォーカス
      Vue.nextTick().then(() => {
        this.focusTextField();
      });
    }
  }

  /**
   * 入力フィールドにフォーカスする
   */
  private focusTextField() {
    (this.$refs.inputField as InstanceType<typeof HTMLFormElement>).focus();
  }

  private get currentTitle(): string | null {
    return this.taskText;
  }
}
